import type {DesignSelection} from '@Components/social-media/social-media.types';

export interface BrandTemplatesTabProps {
  /** The picks made in this tab, so a re-render keeps the selection rings. */
  selectedDesigns: DesignSelection[];
  onSelectionChange: (designs: DesignSelection[]) => void;
  /** "Add brand templates" on an empty kit: the caller moves to the tab designs are picked from. */
  onAddBrandTemplates: () => void;
  /** The kit the picker adds to; it gets no pill, since its own templates are already in it. */
  excludedBrandId?: string;
  /** False while another tab is showing: the tab stays mounted, hidden, so the kit picked in it is kept. */
  isShown: boolean;
}

/** Brand templates are whole designs and carry no page, as the poster-only pickers that show this tab expect. */
export const BRAND_TEMPLATE_PAGE_HASHED_ID = '';

/** The illustration the empty kit shows: the three-template stack the assets dialog's Templates tab uses. */
export const BRAND_TEMPLATES_EMPTY_ILLUSTRATION_PATH = 'brandkit-designs-empty-modal.png';

/** Two rows of the five-column grid: enough to read as the grid without implying how many templates there are. */
export const BRAND_TEMPLATES_SKELETON_CARD_COUNT = 10;

/** The card's thumbnail and name heights, so the skeleton holds the grid's real shape while it loads. */
export const BRAND_TEMPLATES_SKELETON_THUMBNAIL_HEIGHT = 132.8;
export const BRAND_TEMPLATES_SKELETON_NAME_HEIGHT = 16;

/** The kit pills' height and a few representative widths for the row's placeholder. */
export const BRAND_TEMPLATES_SKELETON_PILL_HEIGHT = 48;
export const BRAND_TEMPLATES_SKELETON_PILL_WIDTHS = [176, 148, 132];
